import { createAction, props } from "@ngrx/store";

export const setTourPerfil = createAction(
  '[Tour Perfil] Set Tour Perfil', // este es el nombre de la acción
  props<{ tourPerfil: boolean }>() // este es el payload de la acción, es decir, el valor que se va a establecer en el estado
); // este sirve para establecer el valor de tourPerfil en el estado

export const resetTourPerfil = createAction(
  '[Tour Perfil] Reset Tour Perfil' // este es el nombre de la acción
); // este sirve para restablecer el valor de tourPerfil en el estado a su valor por defecto
